import React, { useEffect, useState } from 'react'
import { firestore } from '../../firebase'

function SelectRegionHandler({region, setRegion}) {

    const [regioner, setRegioner] = useState([]);

    useEffect(() => {
        try {
            const regionRef = firestore.collection("bolig-regioner");
            regionRef.orderBy("region").onSnapshot(({docs}) => {
                const regioner = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                });
                setRegioner(regioner);
            })
        } catch (error) {
            
        }
    })

    return (
        <select className="browser-default custom-select mb-2" onChange={e => setRegion(e.target.value)}>
            <option>Velg region</option>
            {regioner?.map((boligregion, index) => {
                return <option key={index} value={boligregion.kvm_pris}>{boligregion.region}</option>
            })}
        </select>
    )

}
export default SelectRegionHandler;